import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ── Performance : seule la locale par défaut (FR) est bundlée dans le chunk
// initial. La locale EN (≈ 800 lignes) est chargée à la demande dans un chunk
// séparé, au moment où l'utilisateur bascule la langue — ou, pour un visiteur
// ayant déjà choisi EN, en idle après le premier paint (sans bloquer le LCP).
import frCommon from "./locales/fr/common.json";

export const LANGS = ["fr", "en"];

const SAVED = (() => {
  try {
    const v = localStorage.getItem("tchatix-lang");
    return LANGS.includes(v) ? v : null;
  } catch {
    return null;
  }
})();

i18n.use(initReactI18next).init({
  resources: {
    fr: { common: frCommon },
  },
  lng: "fr", // premier paint toujours en FR (rapide) ; EN appliqué après si nécessaire
  fallbackLng: "fr",
  partialBundledLanguages: true,
  defaultNS: "common",
  ns: ["common"],
  interpolation: { escapeValue: false },
});

// Charge la locale EN à la demande (chunk dynamique) — idempotent.
let _enPromise;
export function ensureLocale(lng) {
  if (lng === "en" && !i18n.hasResourceBundle("en", "common")) {
    _enPromise =
      _enPromise ||
      import("./locales/en/common.json").then((m) => {
        i18n.addResourceBundle("en", "common", m.default, true, true);
      });
    return _enPromise;
  }
  return Promise.resolve();
}

// Un visiteur revenant qui avait choisi EN : on recharge EN après le premier
// paint (idle), puis on bascule — sans pénaliser le FCP/LCP du premier passage.
if (SAVED === "en") {
  const ric =
    (typeof window !== "undefined" && window.requestIdleCallback) ||
    ((cb) => setTimeout(cb, 1500));
  ric(() => {
    ensureLocale("en").then(() => i18n.changeLanguage("en"));
  });
}

export default i18n;